// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___J2an","left":"styles_left__3bxGe","desktopActions":"styles_desktopActions__3NaYf","title":"styles_title__2Eh10"};